import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { ArrowUpMIcon } from '@alfalab/icons-glyph/ArrowUpMIcon';
import { ArrowDownMIcon } from '@alfalab/icons-glyph/ArrowDownMIcon';

import styles from '../styles.css';
import type { ITrendArrow } from '../models';

export const TrendArrowDesktop: FC<ITrendArrow> = ({
    className,
    negativeColor = 'negative',
    positiveColor = 'positive',
    up,
}) =>
    up ? (
        <ArrowUpMIcon className={cn(className, styles[positiveColor])} data-test-id="trend-icon" />
    ) : (
        <ArrowDownMIcon
            className={cn(className, styles[negativeColor])}
            data-test-id="trend-icon"
        />
    );
